import 'reflect-metadata'
import React from 'react'
import { render } from 'react-dom'
import FairsService from '@webmotors/wm-portal-lib-api-fairs'
import { config } from 'config/config'
import { useTargetApi as targetApi } from '@/modern/hooks/useTargetApi'

import '@/scss/normalize.css'
import '@/scss/global.scss'
import '@/scss/layout.scss'

import { loadableReady } from '@loadable/component'
import App from './App'

const { env, novaRB, recommendationSimilarityDA, recommendationSimilarityPostLead } = config.abTest

FairsService.setConfigurationLib({
  baseURLFairs: config.urlApi,
})


const mboxes = [
  {
    name: novaRB.mboxName,
    keys: novaRB.keys,
  },
  {
    name: recommendationSimilarityDA.mboxName,
    keys: recommendationSimilarityDA.keys,
  },
  {
    name: recommendationSimilarityPostLead.mboxName,
    keys: recommendationSimilarityPostLead.keys,
  },
]

const targetApiPromise = () =>
  new Promise(resolve =>
    targetApi({
      mboxes,
      env,
      callback: () => resolve(),
    })
  )

Promise.all([targetApiPromise()]).then(() => {
  loadableReady(() => {
    render(<App />, document.getElementById('root'))
  })
})
